import plansByCarrierIdSelector from './plansByCarrierIdSelector';
import { createSelector } from 'reselect';

const plansSelector = createSelector(
    plansByCarrierIdSelector,
    (state, carrierId) => carrierId,
    (plansByCarrierId, carrierId) => plansByCarrierId[carrierId]
);

export default plansSelector;
